import React, { FC, useRef, useState } from 'react';
import { BulletsEntity } from './game';
import { useFrame } from '@react-three/fiber';
import { Box } from '../../../../components';
import { Vector } from '../../../../types';

export type ControlledBulletsProps = {
  bulletsEntity: BulletsEntity;
  size?: Vector;
  color?: string;
};

export const ControlledBullets: FC<ControlledBulletsProps> = ({
  bulletsEntity,
  size = [2, 2, 2],
  color = '#fff',
}) => {
  const ref = useRef<any[]>([]);
  const [len, setLen] = useState<number>(bulletsEntity.positions.length);

  useFrame(() => {
    bulletsEntity.positions.forEach(([x, y, z], i) => {
      if (ref.current[i]) {
        ref.current[i].position.x = x - size[0] / 4;
        ref.current[i].position.y = y - size[1] / 2;
        ref.current[i].position.z = z - size[2] / 2;
      }
    });
    if (len !== bulletsEntity.positions.length) {
      setLen(bulletsEntity.positions.length);
    }
  });

  return (
    <>
      {bulletsEntity.positions.map((position, i) => (
        <Box
          key={i}
          ref={(el: any) => (ref.current[i] = el)}
          position={position}
          size={size}
          color={color}
          emissive={color}
        />
      ))}
    </>
  );
};
